import { Controller } from '@hotwired/stimulus';
import NwAvatar from '../libs/nw_avatar';

export default class extends Controller {
  static targets = ['output'];

  connect() {
    const avatarImageData = this.outputTarget.getAttribute('data-image');

    if (avatarImageData) {
      this.outputTarget.innerHTML = NwAvatar.createAvatarSVG(avatarImageData);
    } else {
      const randomAvatar = NwAvatar.createRandomAvatar();
      this.outputTarget.innerHTML = NwAvatar.createAvatarSVG(randomAvatar.toString());
    }
  }

  declare outputTarget: HTMLElement;
}
